import { render, staticRenderFns } from "./ProductValueYieldStatistics.vue?vue&type=template&id=ca3b2204&scoped=true&"
import script from "./ProductValueYieldStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductValueYieldStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProductValueYieldStatistics.vue?vue&type=style&index=0&id=ca3b2204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b2204",
  null
  
)

export default component.exports